import { DateTime } from 'luxon';
import { Guid } from '../../classes/guid';
import { ObjectState } from '../../enums/objectState.enum';
import { IConfigObjectBase } from '../../interfaces/config-objects/config-object-base';

export class ProjectSpaceConfig implements IConfigObjectBase {
	id: string = Guid();
	name = '';
	description?: string;
	dateCreated: DateTime = DateTime.now();
	lastUpdated: DateTime = DateTime.now();
	objectState?: ObjectState;
	/**
	 * List of integration referenceIDs that are associated with this project space.
	 */
	integrationIDs: string[] = [];

	constructor(init?: Partial<ProjectSpaceConfig>) {
		if (init) {
			Object.assign(this, init);
		}
	}
}
